export default "__VITE_ASSET__Ddv16vp9__"